import { createRouter, createWebHashHistory, type RouteRecordRaw } from "vue-router";
// import Page404 from "@/pages/404.vue";

const routes: RouteRecordRaw[] = [
  { path: "/", name: "home", component: () => import("./views/Home.vue") },
  {
    path: "/news",
    children: [
      { path: "", name: "news", component: () => import("./views/NewsList.vue") },
      {
        path: "details",name: "news-detail",component: () => import("./views/NewsDetail.vue"),
        props: route => ({ sn: route.query.sn, cn: route.query.cn })
      }
    ]
  },
  // {
  //   path: "/:pathMatch(.*)*",
  //   name: "NotFound",
  //   component: Page404,
  // },
];

export const mainRouter = createRouter({
  history: createWebHashHistory(),
  routes
});
